import React, { Component } from "react";
import { List, Modal, Row, Col } from "antd";

import LangContext from "modules/shared/context/langContext";

// row is one line of the list: what is described on the left and its meaning (i18n.g key) on the right.
const row = (left, key) => ({
    desc: (
        <Row style={{}}>
            <Col span={5}>{left}</Col>
            <Col span={18} offset={1}>
                <LangContext.Consumer>{(i18n) => i18n.g[key]}</LangContext.Consumer>
            </Col>
        </Row>
    ),
});

// color is a cell color with its meaning.
const color = (background, key) =>
    row(
        <div
            style={{
                width: "23px",
                height: "23px",
                backgroundColor: background,
                borderRadius: "6px",
            }}
        ></div>,
        key
    );

// metric is a column of the table with what it measures, then its colors and N/A when it has them.
const metric = (name, key, colors) => [row(<h4>{name}</h4>, key), ...colors];

// gpsColors are the colors of a column passed at 95% (GPS, Card Reader and the camera).
const gpsColors = [
    color("#00D090", "gpsPerformanceDesGreen"),
    color("#F7DE57", "gpsPerformanceDesYellow"),
    color("#F44B51", "gpsPerformanceDesRed"),
];

const na = row(<h4>N/A</h4>, "gpsPerformanceDesNA");

export class IconDescModal extends Component {
    // the columns in the order of the table
    state = {
        data: [
            ...metric("GPS", "gpsPerformanceDesGPS", [...gpsColors, na]),
            ...metric("Sensor", "gpsPerformanceDesDrumSensor", [
                color("#00D090", "drumSensorPerformanceDesGreen"),
                color("#F7DE57", "drumSensorPerformanceDesYellow"),
                color("#F44B51", "drumSensorPerformanceDesRed"),
                na,
            ]),
            ...metric("Card Reader", "gpsPerformanceDesCard", gpsColors),
            ...metric(
                <LangContext.Consumer>{(i18n) => i18n.c.camera}</LangContext.Consumer>,
                "gpsPerformanceDesCamera",
                [...gpsColors, na]
            ),
        ],
    };

    render() {
        return (
            <Modal
                style={{ top: 20 }}
                // the list scrolls inside the modal, which fits the window
                bodyStyle={{ maxHeight: "calc(100vh - 160px)", overflowY: "auto" }}
                title={
                    <LangContext.Consumer>
                        {(i18n) => i18n.i.iconDesc}
                    </LangContext.Consumer>
                }
                visible={this.props.iconDetailVisible}
                onOk={this.props.handleIconDetailCancel}
                onCancel={this.props.handleIconDetailCancel}
                cancelButtonProps={{ style: { display: "none" } }}
                okText={
                    <LangContext.Consumer>{(i18n) => i18n.o.okay}</LangContext.Consumer>
                }
            >
                <List
                    itemLayout="horizontal"
                    dataSource={this.state.data}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={item.image}
                                title={item.title}
                                description={item.desc}
                            />
                        </List.Item>
                    )}
                />
            </Modal>
        );
    }
}

export default IconDescModal;
